// extracted by mini-css-extract-plugin
export default {"slick-prev":"arrow_slick-prev__hngV8","slick-next":"arrow_slick-next__9o0Ji","nextArrow":"arrow_nextArrow__GRLds","prevArrow":"arrow_prevArrow__tH33i"};